import {getGlobal, setGlobal} from 'reactn';
import {CONFIG} from './config';

export type tableStatus =
	'untouched' |
	'failed' |
	'counting' |
	'counted' |
	'updating' |
	'updated';

export interface Table {
	checked: boolean;
	count: number;
	label: string;
	status: tableStatus;
}

export interface Tables {
	[ table: string ]: Table;
}


export interface GlobalState {
	isSections: boolean;
	lastChecked: number; // Simple tracking for any checkbox changing.
	newUrl: string;
	oldUrl: string;
	tables: Tables;
	sections: Tables;
	updating: boolean;
}

export function getState( property?: undefined ): GlobalState;
export function getState<T extends keyof GlobalState>(
	property: T
): GlobalState[T];
export function getState( property ) {
	if ( typeof property !== 'undefined' ) {
		return getGlobal()[ property ];
	}
	return getGlobal();
}

export function setState( state: Partial<GlobalState> ): Promise<GlobalState> {
	return setGlobal<GlobalState>( state );
}

const setInitialState = (): void => {
	const tables: Tables = {};
	const sections: Tables = {};
	Object.keys( CONFIG.sections ).forEach( section => {
		CONFIG.sections[ section ].tables.forEach( name => tables[ name ] = {
			checked: true,
			count: 0,
			label: name,
			status: 'untouched',
		} );

		sections[ section ] = {
			checked: true,
			count: 0,
			label: CONFIG.sections[ section ].label,
			status: 'untouched',
		};
	} );

	setGlobal<GlobalState>( {
		isSections: true,
		lastChecked: 0,
		newUrl: CONFIG.newUrl,
		oldUrl: CONFIG.oldUrl,
		sections,
		tables,
		updating: false,
	} );
};
export default setInitialState;
